import { render, staticRenderFns } from "./CustomerSign.vue?vue&type=template&id=35b422b0&scoped=true"
import script from "./CustomerSign.vue?vue&type=script&lang=js"
export * from "./CustomerSign.vue?vue&type=script&lang=js"
import style0 from "./CustomerSign.vue?vue&type=style&index=0&id=35b422b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b422b0",
  null
  
)

export default component.exports